import React, { useEffect, useState } from 'react';
import { Zap, SearchCheck, Loader2 } from 'lucide-react';
import { PageHeader, Card, inputCls } from '../ui';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { api, eur } from '../api';
import { CountryLabel, COUNTRIES } from '../countries';
import SearchPage from './SearchPage';
import Investigations from '../estero/Investigations';
import { WORLD, countryName } from '../estero/worldCountries';

function Mode({ online, price, notFound, onBack }) {
  const Icon = online ? Zap : SearchCheck;
  return (
    <div className={`flex gap-3 border-l-2 px-4 py-3 text-sm ${online ? 'border-[#2E9E6A] bg-[#2E9E6A]/[0.07]' : 'border-[#D4AF37] bg-[#D4AF37]/[0.06]'}`} data-testid={`estero-mode-${online ? 'online' : 'offline'}`}>
      <Icon size={17} className={online ? 'text-[#5FC18F] shrink-0' : 'text-[#D4AF37] shrink-0'} />
      <p className="text-[#C9CCD1]">{online
        ? <><b className="text-[#F2F2F2]">Report in tempo reale.</b> Il Paese è coperto dalla banca dati: cerca l'azienda e ricevi subito il report. Il monitoraggio si attiva in automatico.</>
        : notFound ? <><b className="text-[#F2F2F2]">Azienda non trovata nella banca dati.</b> Puoi richiedere un'investigazione: un analista raccoglie le informazioni e carica il report in PDF, di solito in 5-10 giorni lavorativi. Prezzo unico <b className="text-[#D4AF37]">{eur(price)}</b>. <button onClick={onBack} className="text-[#D4AF37] underline ml-1" data-testid="estero-back-to-search">Torna alla ricerca</button></>
        : <><b className="text-[#F2F2F2]">Serve un'investigazione.</b> Il Paese non è disponibile in tempo reale: un analista raccoglie le informazioni e carica il report in PDF, di solito in 5-10 giorni lavorativi. Prezzo unico <b className="text-[#D4AF37]">{eur(price)}</b>.</>}</p>
    </div>
  );
}

export default function EsteroPage() {
  const [info, setInfo] = useState(null);
  const [country, setCountry] = useState('');
  const [investigate, setInvestigate] = useState(null);
  useEffect(() => { api.get('/foreign/countries').then((r) => setInfo(r.data)).catch(() => setInfo({ online: [], price_cents: 0 })); }, []);
  if (!info) return <Loader2 className="animate-spin text-[#D4AF37]" />;
  const online = new Set(info.online ?? COUNTRIES.map(([c]) => c).filter((c) => c !== 'IT'));
  const isOnline = online.has(country) && !investigate;
  const pick = (c) => { setCountry(c); setInvestigate(null); };
  return (
    <div data-testid="estero-page">
      <PageHeader kicker="Aziende internazionali" title="Estero" />
      <Card className="p-6 mb-8">
        <label className="block text-[11px] uppercase tracking-[0.18em] text-[#7A7F87] mb-2">Paese dell'azienda</label>
        <div className="grid lg:grid-cols-[320px_1fr] gap-4 items-start">
          <Select value={country} onValueChange={pick}>
            <SelectTrigger className={inputCls} data-testid="estero-country"><SelectValue placeholder="Scegli il Paese…" /></SelectTrigger>
            <SelectContent className="bg-[#0B0D10] border-[#1F242C] text-[#E5E5E5] max-h-[360px]">
              {[...WORLD].sort((a, b) => online.has(b[0]) - online.has(a[0])).map(([c, l]) => (
                <SelectItem key={c} value={c} data-testid={`estero-country-${c}`}>
                  <span className="flex items-center gap-2"><CountryLabel code={c} name={l} />{online.has(c) && <Zap size={12} className="text-[#5FC18F]" />}</span>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {country ? <Mode online={isOnline} price={info.price_cents} notFound={!!investigate} onBack={() => setInvestigate(null)} /> : <p className="text-sm text-[#8A8F97] py-2">I Paesi con il simbolo <Zap size={12} className="inline text-[#5FC18F]" /> hanno il report in tempo reale; per gli altri serve un'investigazione.</p>}
        </div>
      </Card>
      {country && isOnline && <SearchPage foreign country={country} key={country} onNotFound={(name) => setInvestigate({ company_name: name })} />}
      {(!country || !isOnline) && <Investigations key={`${country}-${investigate?.company_name || ''}`} initial={country ? { country: countryName(country), ...(investigate || {}) } : null} price={info.price_cents} />}
    </div>
  );
}
